import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';
import { RosaCategoriesEnum } from '../types';
import { ROSA_QUERY_KEYS } from './query-keys';
import type { BaseContext, TaskType } from '@/types';
import { RosaSubCategoryEnum } from '../Steps/Evaluation/constants';

type SubCategoryElements = {
	required: string;
	duration?: number;
	not_required?: Record<string, boolean>;
};

type SubCategories = Record<RosaSubCategoryEnum, SubCategoryElements>;

type RequiredElement = {
	action: string;
	priority: number;
};

type ActionPlanTask = {
	id: string;
	description: string;
	type: TaskType;
};

type ActionPlan = {
	category_name: string;
	action_plan_id: string;
	title: string;
	responsible_user_id: string;
	deadline: Date;
	description: string;
	tasks: ActionPlanTask[];
};

type GetRosaRequest = BaseContext & {
	id: string;
};

export type GetRosaResponse = {
	id: string;
	file: {
		id: string;
		original_name: string;
		uploaded_date: Date;
	};
	informations: {
		name: string;
		organization_id: string;
		company_id: string;
		sector_id: string;
		line_id: string;
		workstation_id: string;
		activity_id: string;
		evaluator_id: string;
		collection_date: Date;
		analysis_date: Date;
	};
	step: number;
	comment: string;
	consolidated: boolean;
	action_plan: ActionPlan[];
	required_elements: Record<string, RequiredElement>;
	evaluation: Record<RosaCategoriesEnum, SubCategories>;
};

async function getReport(params: GetRosaRequest): Promise<GetRosaResponse> {
	const { id } = params;

	const url = `ergonomic-tool/rosa/${id}`;
	const { data } = await Api.get(url, { params });

	return data;
}

export const useGetRosaData = (params: GetRosaRequest) => {
	const data = useQuery([ROSA_QUERY_KEYS.GET_ROSA], () => getReport(params), {
		retry: 0
	});
	return data;
};
